import type { Loan } from '@taler/api-client'

export type DrawnState = 'drawn' | 'not-drawn' | 'unknown'

/**
 * Nothing outstanding and no accrual ever ran is ambiguous on its own: never drawn, or drawn and repaid
 * before an accrual. The principal account's history settles it; until that is known (`undefined`) the
 * loan is neither labelled drawn nor not drawn.
 */
export function drawnState(loan: Loan, hasHistory: boolean | undefined): DrawnState {
  const untouched =
    loan.outstandingPrincipal.units === 0n && loan.accruedInterest.units === 0n && loan.accrualCount === 0
  if (!untouched) return 'drawn'
  if (hasHistory === undefined) return 'unknown'
  return hasHistory ? 'drawn' : 'not-drawn'
}
